<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>

  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Role Management</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
    <v-tabs
        v-model="tab1" grow
        next-icon="mdi-arrow-right-bold-circle"
        prev-icon="mdi-arrow-left-bold-circle"
        show-arrows
        dark center-active
        background-color= "#2A353D"
        height = "56px"
        slider-size = "4"
    >
        <v-tabs-slider color="#81DBF6"></v-tabs-slider>

        <v-tab v-for="roles in allRoles" :key="roles.SecurityRoleID" @click="editRoleUsers(roles)" >
          <div>
            <v-chip class="mt-1" small fab outlined elevation="0" color="white">
              <div class="white--text font-weight-bold mb-0">{{roles.User.length}}
              </div><div class="white--text text-lowercase caption font-weight-light title ml-1">users</div>
            </v-chip>
            <h6 class="caption text-capitalize font-weight-normal text-truncate">{{roles.Role}}</h6>
          </div>
        </v-tab>
    </v-tabs>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="460"
    :headers="headers"
    :items="confirmedRoles ? allRoles.filter(a => a.CheckerID !== 0) : allRoles.filter(a => a.CheckerID === 0)"
    :search="search"
    sort-by="username"
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top>
      <v-form class="edit elevation-6" ref="form" v-model="valid" lazy-validation v-if="create" >
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New Role</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-text-field
            dense filled
            color="#2A353D"
            append-icon="mdi-qrcode-scan"
            v-model="roles.RoleCode"
            label="Role Code"
            required
            :rules="RoleCodeRules"
          ></v-text-field> 
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            append-icon="mdi-label"
            v-model="roles.Role"
            label="Role Name"
            required
            :rules="RoleNameRules"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            append-icon="mdi-card-text"
            v-model="roles.Description"
            label="Description"
            required
            :rules="DescriptionRules"
          ></v-text-field>
          <div class="text-right">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
            <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
          </div>
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-form class="edit elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Edit Role</v-toolbar-title>
          <v-spacer/>          
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-text-field
            dense filled
            color="#2A353D"
            append-icon="mdi-qrcode-scan"
            v-model="currentRole.RoleCode"
            label="Role Code"
            required
            :rules="RoleCodeRules"
          ></v-text-field>

          <v-checkbox
            v-model="currentRole.IsDisabled"
            class="mt-0"
            label="Role is Disabled?"
          ></v-checkbox>          
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            append-icon="mdi-label"
            v-model="currentRole.Role"
            label="Role Name"
            required
            :rules="RoleNameRules"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            append-icon="mdi-card-text"
            v-model="currentRole.Description"
            label="Description"
            required
            :rules="DescriptionRules"
          ></v-text-field>
          <div class="text-right">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="closeEdit()">close</v-btn>
            <v-btn class="white--text mr-3" small color="#2A353D" @click="update()">save</v-btn>          
          </div>
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-container row>
        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedRoles" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedRoles" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Roles.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Roles.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-if="confirmedRoles" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-if="!confirmedRoles" @click="confirmedRoles = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>

      <v-dialog v-model="dialog" max-width="500px">
        <UserList :users="role.User"/>
      </v-dialog>  

      <v-dialog v-model="dialog2" persistent max-width="1000px">

        <v-snackbar
          :value="showMessage()"
          multi-line
          color="#686868"
          top
          
        >
          {{message}}
        </v-snackbar>

        <!-- <RolePermissions :permissions="permissions" :name="item.Role" :role_permissions="item.role_permission"/> -->
        <v-card height="640" class="mt-0" id="permissionList" flat>
          <v-toolbar dense flat tile color="#2A353D">
            <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{roleName}} Permissions</v-toolbar-title>
            <v-spacer/>
            <v-btn fab x-small outlined color="#81DBF6" @click="close()"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-tabs
              v-model="tab"
              next-icon="mdi-arrow-right-bold-circle"
              prev-icon="mdi-arrow-left-bold-circle"
              show-arrows
              dark center-active
              background-color= "#2A353D"
              height = "40px" class="mb-0"
              slider-size = "4"
          >
              <v-tabs-slider color="#81DBF6"></v-tabs-slider>

              <v-tab v-for="authority in authorities" :key="authority.FunctionName" @change="matchedPermissions = []" >
                  <h6 class="caption text-capitalize font-weight-normal">{{ authority.FunctionName }}</h6>
              </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="authority in authorities"
              :key="authority.FunctionName"
            >
              <v-card flat>
                <v-data-table
                  dense fixed-header
                  :height="480"
                  disable-pagination
                  hide-default-footer
                  :headers="headers2"
                  :items="matchedPermissions"
                  :search="search"
                  sort-by="FunctionID"
                  class="elevation-0 mt-2"
                >
                  <template v-slot:item.FunctionID="{ item }">
                    <span class="grey--text subtitle-1 font-weight-bold">{{getPermissionName(item.FunctionID)}}</span>
                  </template>
                  <template v-slot:item.AllowEdit="{ item }">
                    <v-simple-checkbox
                      @input="captureChange(item)"
                      v-model="item.AllowEdit"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.AllowCreate="{ item }">
                    <v-simple-checkbox
                      @input="captureChange(item)"
                      v-model="item.AllowCreate"
                    ></v-simple-checkbox> 
                  </template>
                  <template v-slot:item.AllowDelete="{ item }">
                    <v-simple-checkbox
                      @input="captureChange(item)"
                      v-model="item.AllowDelete"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.AllowView="{ item }">
                    <v-simple-checkbox
                      @input="captureChange(item)"
                      v-model="item.AllowView"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.AllowConfirm="{ item }">
                    <v-simple-checkbox
                      @input="captureChange(item)"
                      v-model="item.AllowConfirm"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.AllowSettle="{ item }">
                    <v-simple-checkbox
                      @input="captureChange(item)"
                      v-model="item.AllowSettle"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.AllowConfirmSettle="{ item }">
                    <v-simple-checkbox
                      @input="captureChange(item)"
                      v-model="item.AllowConfirmSettle"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.AllowOverride="{ item }">
                    <v-simple-checkbox
                      @input="captureChange(item)"
                      v-model="item.AllowOverride"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.AllowReversal="{ item }">
                    <v-simple-checkbox
                      @input="captureChange(item)"
                      v-model="item.AllowReversal"
                    ></v-simple-checkbox>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

          <v-divider class="mt-0"/>
          <div class="text-right mr-4 mt-5">
            <v-btn class="white--text" small color="#2A353D" @click="updatePermissions()">
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              save
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedRoles && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveRole(item, index); confirm()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-2"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-btn
      class="ml-1" outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
      color="#2A353D" small @click="setActiveRole(item, index); showEdit(); closeCreate()">
        edit
      </v-btn>
      <v-btn v-on="on" class="ml-2" outlined small color="#2A353D" @click="setActiveRole(item, index); editPermissions(item)">
          Permissions
      </v-btn>
    </template>

    <template v-slot:item.IsDisabled="{ item }">
      <v-chip color="error" small outlined v-if="item.IsDisabled == 1">disabled</v-chip>
      <v-chip color="success" small outlined v-else>active</v-chip>
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import UserList from './Roles.Users_List'
import jsPDF from 'jspdf';
import 'jspdf-autotable'
// import RolePermissions from './RolePermissions'

export default {
  name: 'role-management',

  components: {
    UserList,
    // RolePermissions
  },

  data () {
    return {
      confirmedRoles: true,
      edit: false,
      tab: null,
      create: false,
      dialog: false,
      dialog2: false,
      message: '',
      permitted: null,
      permitted_dialog: true,
      valid: true,
      loading: false,
      search: '',
      currentRole: null,
      currentIndex: -1,
      CurrentDataset: [],
      pendingUpdates: [],
      role_permission: [],
      matchedAuthorities: [],
      matchedPermissions: [],
      headers: [
        {
          text: 'Role Code',
          align: 'start',
          sortable: true,
          value: 'RoleCode'
        },
        { text: 'Role', value: 'Role', sortable: false },
        { text: 'Description', value: 'Description', sortable: false },
        { text: 'Status',value: 'IsDisabled', sortable: false },
        { value: 'actions',align: 'end', sortable: false },
      ],
      headers2: [
        { text: 'Function Name', value: 'FunctionID', sortable: true },
        { text: 'Edit', align: 'center', value: 'AllowEdit', sortable: false },
        { text: 'Create', value: 'AllowCreate', sortable: false },
        { text: 'Delete',value: 'AllowDelete', sortable: false },
        { text: 'View', value: 'AllowView', sortable: false },
        { text: 'Confirm', value: 'AllowConfirm', sortable: false },
        { text: 'Settle', align: 'center', value: 'AllowSettle', sortable: false },
        { text: 'Confirm Settle', align: 'center', value: 'AllowConfirmSettle', sortable: false },
        { text: 'Override', value: 'AllowOverride', sortable: false },
        { text: 'Allow Reversal', value: 'AllowReversal', sortable: false },      
      ],
      RoleCodeRules: [
        v => !!v || 'Role code is required',
        v => (v && v.length <= 10) || 'field must be less than 10 characters'
      ],
      RoleNameRules: [
        v => !!v || 'Role name is required',
        v => (v && v.length <= 40) || 'field must be less than 40 characters'
      ],
      DescriptionRules: [
        v => !!v || 'Description is required',
        v => (v && v.length <= 200) || 'field must be less than 200 characters'
      ],
      roleIndex: -1,
      role: [],
      roles: {},
      submitted: false,
    }
  },

  watch: {
    dialog2 (val) {
      val || this.close()
    },
    dialog (val) {
      val || this.close()
    },
    tab: function(newValue) {
      if(newValue != null){
        this.getMatchingAuthorities(this.authorities[newValue].FunctionID);
        this.getRoleFunctions()
      }
    },
  },

  computed: {
    ...mapGetters([
      "allPermissions",
      "allRoles",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    authorities(){
      return this.allPermissions.filter(p => p.ParentNode === 0)
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 502).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 502).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 502).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 502).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 502).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createRole",
      "updateRole",
      "updateRolePermissions",
    ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.roles.MakerID = this.currentUser.SecurityUserID,
        this.roles.CheckerID = this.CheckerID,
        this.roles.LastUserID = this.currentUser.SecurityUserID,
        this.createRole(this.roles)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newRole',
            data: response.data
          });
          this.message = response.data.message
          this.reset()
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      }
    },

    async update() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.currentRole.MakerID = this.currentUser.SecurityUserID
        this.currentRole.LastUserID = this.currentUser.SecurityUserID,
        this.currentRole.CheckerID = 0,
        this.currentRole.CheckDate = null,
        this.currentRole.MakeDate = new Date(),

        this.updateRole(this.currentRole)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updRole',
            data: this.currentRole
          });
          
          this.message = response.data.message
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      }
    },

    updatePermissions() {
      this.message = '';
      this.loading = true;

      for (let i = 0; i < this.pendingUpdates.length; i++) {
        this.pendingUpdates[i].MakerID= this.currentUser.SecurityUserID,
        this.pendingUpdates[i].LastUserID = this.currentUser.SecurityUserID,
        this.pendingUpdates[i].CheckerID = this.currentUser.SecurityUserID,
        this.pendingUpdates[i].CheckDate = new Date(),
        this.pendingUpdates[i].MakeDate = new Date(),
        this.pendingUpdates[i].SecurityRoleID = this.currentRole.SecurityRoleID, 

        this.updateRolePermissions(this.pendingUpdates[i])
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updRolePermissions',
            data: this.pendingUpdates[i]
          });
          if(i == this.pendingUpdates.length - 1){
            this.message = response.data.message;
            this.pendingUpdates = [];
            // this.close();
            this.loading = false
          }
        },
        error => {
          this.loading = false;
          return this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
        })
      }
    },

    confirm() {
      this.message = '';

      this.currentRole.CheckerID = this.currentUser.SecurityUserID,
      this.currentRole.LastUserID = this.currentUser.SecurityUserID,
      this.currentRole.CheckDate = new Date(),
      this.currentRole.updatedAt = new Date(),

      this.updateRole(this.currentRole)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updRole',
          data: this.currentRole
        });
        
        this.message = response.data.message
        this.closeEdit()
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Roles", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Roles.pdf')
      }
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedRoles = false
    },

    setActiveRole (role, index) {
      this.currentRole = role
      this.currentIndex = index
    },

    editPermissions (item) {
      this.roleIndex = this.allRoles.indexOf(item)
      this.roleName = item.Role
      this.tab = 0
      this.role_permission = item.role_permission
      this.dialog2 = true
    },

    editRoleUsers(role) {
      this.roleUserIndex = this.allRoles.indexOf(role)
      this.role = role
      this.dialog = true
    },

    closeRoleUsers () {
      this.dialog = false
      this.$nextTick(() => {
        this.role = '',
        this.roleUserIndex = -1
      })
    },

    close () {
      this.dialog2 = false;
      this.tab = null;
      this.pendingUpdates = [];
      this.$nextTick(() => {
        this.roleName = '',
        this.matchedPermissions = [],
        this.roleIndex = -1
      })
    },

    captureChange(item){
      if(this.pendingUpdates.map(p => p.FunctionID).includes(item.FunctionID) == true){
        var index = this.pendingUpdates.findIndex(p => p.FunctionID == item.FunctionID)
        this.pendingUpdates.splice(index, 1, item)
      } else {
        this.pendingUpdates.push(item)
      }
    },

    getMatchingAuthorities(data) {
      this.matchedAuthorities = this.allPermissions.filter(p => p.ParentNode === data)
    },

    getPermissionName(id) {
      return this.allPermissions.filter(p => p.FunctionID === id).map(p => p.FunctionName).toLocaleString()
    },

    getRoleFunctions() {
      // return this.matchedPermissions = this.role_permissions.filter(r => r.FunctionID == info)
      for (let i = 0; i < this.matchedAuthorities.length; i++) {
        this.matchedPermissions[i] = this.role_permission.find(r => r.FunctionID == this.matchedAuthorities[i].FunctionID);
      }
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.create = false
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isRoles().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("closeRoleUsers", () => {
      this.closeRoleUsers();
    });
    this.$root.$on("unconfirmedRoles", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
};

.v-btn {
  outline: none
}

.title {
    color:#2A353D ;
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white;
};
</style>
